<ng-container>
  <div class="row">
    @if (views) {
      <div class="col text-center mb-3">
        <ng-container *ngTemplateOutlet="pager"></ng-container>
      </div>
    }
  </div>
  <div class="row justify-content-between">
    <div class="col-9 pr-2" [ngClass]="{'col-12': (view?.id === 0 || view?.id === 2)}" [hidden]="isPreviewActivated">
      <ng-container *ngTemplateOutlet="normal"></ng-container>
    </div>
    <div id="data-studio-preview" class="col-9 pr-2" [hidden]="!isPreviewActivated">
      <ng-container *ngTemplateOutlet="preview"></ng-container>
    </div>
    @if (view?.id && view?.id !== 2) {
      <div class="col-3">
        <div class="col-12 p-3 mb-3 data-files-summary">
          @if (view?.id == 1) {
            <div class="col-xl">
              <app-data-file-summary [selectedPage]="view?.id"
              [(isPreviewSelected)]="isPreviewActivated"></app-data-file-summary>
            </div>
          }
          @if (view?.id == 3) {
            <div class="col-xl">
              <app-data-file-summary [selectedPage]="view?.id" [(isPreviewSelected)]="isPreviewActivated"
              [displayPreviewButton]="false"></app-data-file-summary>
            </div>
          }
          @if (view?.id == 4) {
            <div class="col-xl">
              <app-data-file-summary [selectedPage]="view?.id"
              [(isPreviewSelected)]="isPreviewActivated"></app-data-file-summary>
            </div>
          }
          @if (view?.id == 5) {
            <div class="col-xl">
              <app-data-file-summary [selectedPage]="view?.id"
                [(isPreviewSelected)]="isPreviewActivated"
                [displayPreviewButton]="false"
                [fileFormat]="'onlyExcel'">
              </app-data-file-summary>
            </div>
          }
        </div>
        @if (view?.id !== 5) {
          <div class="col-12 p-3 data-files">
            @if (view?.id == 1) {
              <div class="col-xl">
                <app-data-files [type]="'scada'"></app-data-files>
              </div>
            }
            @if (view?.id == 3) {
              <div class="col-xl">
                <app-data-files [type]="'tlog'"></app-data-files>
              </div>
            }
            @if (view?.id == 4) {
              <div class="col-xl">
                <app-data-files [type]="'parkdata'"></app-data-files>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-container>

<ng-template #pager>
  @if (views) {
    <app-page-navigation [items]="views" (activeChanged)="setView($event)">
    </app-page-navigation>
  }
</ng-template>
<ng-template #dataAnalysis>
  <app-data-analysis></app-data-analysis>
</ng-template>
<ng-template #liveData>
  <app-data-live-data>
  </app-data-live-data>
</ng-template>
<ng-template #scada>
  <app-data-scada></app-data-scada>
</ng-template>
<ng-template #tlogs>
  <app-data-turbine-log></app-data-turbine-log>
</ng-template>
<ng-template #parkData>
  <app-data-park></app-data-park>
</ng-template>
<ng-template #preview>
  @if (view?.id !== 2) {
    <lib-card >
      <lib-card-header>
        <div class="row mb-3">
          <div class="col-md-6">
            <strong>{{'DATA_STUDIO.PAGER.DATA_PREVIEW' | translate }}</strong>
          </div>
          <div class="col-md-6 text-right">
            <div class="input-prepend">
              <lib-button
                id="data-studio-redesign-button-close-preview"
                class="mr-2"
                [color]="'secondary'"
                [faIcon]="'far fa-eye'"
                [label]="'DATA_STUDIO.DATA_FILE_SUMMARY.CLOSE_PREVIEW' |translate"
                (buttonClicked)="closePreview()" >
              </lib-button>
            </div>
          </div>
        </div>
      </lib-card-header>
      <lib-card-body>
        <mat-tab-group animationDuration="100ms" [(selectedIndex)]="selectedTab">
          <mat-tab [label]="('DATA_STUDIO.PREVIEW.SINGLE_' + singleAssetLabel | translate)">
            <div class="d-flex flex-wrap">
              <div class="p-2 signals-preview-dropdown">
                <mat-label>{{'COMMON.' + singleAssetLabel | translate }}</mat-label>
                @if (turbinesNames) {
                  <lib-select [options]="selectedDevicesNames" [label]="selectedDevice"
                    id="data-studio-redesign-select-turbine"
                    [border]="'custom-border'" [classes]="'font-size-normal-small text-primary h-100'" [notBold]="true"
                    [fullWidth]="true" [itemClasses]="'font-size-normal-small'" [doNotTranslate]="true" [container]="''"
                    (selectedChanged)="triggerTurbineChange($event)">
                  </lib-select>
                }
              </div>
              <div class="p-2 w-50">
                <mat-label>{{'DATA_STUDIO.PREVIEW.SIGNALS' | translate}}</mat-label>
                <mat-select #multiSignalsSelect [formControl]="multiSignals" disableOptionCentering
                  panelClass="multi-panel" multiple>
                  <mat-select-trigger>
                    {{multiSignalsText}}
                  </mat-select-trigger>
                  <div class="select-all-option" [ngClass]="{'disabled': allUnitsCount > MAX_UNITS_COUNT}">
                    <mat-checkbox [checked]="allSignalsSelected" (change)="triggerAllSignals($event)" [disabled]="allUnitsCount > MAX_UNITS_COUNT">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center justify-content-start">
                          <div class="text-primary">{{'DATA_STUDIO.PREVIEW.SELECT_ALL' | translate }}</div>
                          <div class="ml-2">({{ 'DATA_STUDIO.PREVIEW.ONLY_2_DIFFERENT_UNITS_BY_CHART' | translate }})</div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end">
                          {{' ' + (signalsSelected$ | async)?.length}} {{'COMMON.OF' |translate}} {{signalsAvailables?.length}}
                        </div>
                      </div>
                    </mat-checkbox>
                  </div>
                  <div class="signal-grid">
                    @for (v of signalsAvailables; track $index; let i = $index) {
                      <mat-option
                        [value]="v.value"
                        [matTooltip]="signalsNames[i]"
                        class="data-studio-multi-select"
                        [disabled]="!isSignalSelected(v.unit) && unitsSelected.length === MAX_UNITS_COUNT"
                        (click)="triggerOnePerOneSignal(v.unit)">
                        {{signalsNames[i]}} ({{v.unit}})
                      </mat-option>
                    }
                  </div>
                </mat-select>
              </div>
              <div class="p-2 w-100 mt-3">
                <div class="w-100">
                  @if (selectedTab === 0) {
                    <app-preview-chart
                      class="w-100"
                      [loading]="loadingData"
                      [unitsSelected]="unitsSelected"
                      [series]="series">
                    </app-preview-chart>
                  }
                </div>
              </div>
            </div>
          </mat-tab>
          @if (isMultipleAssetAvailable) {
            <mat-tab [label]="('DATA_STUDIO.PREVIEW.MULTIPLE_' + singleAssetLabel + 'S' | translate)">
              <div class="d-flex flex-wrap">
                <div class="p-2 signals-preview-dropdown">
                  <mat-label>{{'DATA_STUDIO.PREVIEW.SIGNALS' | translate}}</mat-label>
                  @if (signalsNames) {
                    <lib-select
                      [options]="signalsNames"
                      [label]="selectedSignal"
                      [doNotTranslate]="true"
                      id="data-studio-redesign-select-signal-change"
                      [border]="'custom-border'" [classes]="'font-size-normal-small text-primary h-100'" [notBold]="true"
                      [fullWidth]="true" [itemClasses]="'font-size-normal-small'" [container]="''"
                      (selectedChanged)="triggerSignalChange($event)">
                    </lib-select>
                  }
                </div>
                <div class="p-2 w-50">
                  <mat-label>{{'COMMON.' + singleAssetLabel | translate}}s</mat-label>
                  <mat-select disableOptionCentering #multiTurbinesSelect panelClass="multi-panel" multiple
                    [formControl]="multiDevices">
                    <mat-select-trigger>
                      {{multiTurbinesText}}
                    </mat-select-trigger>
                    <div class="select-all-option">
                      <mat-checkbox [checked]="allDevicesSelected" (change)="triggerAllTurbines($event)">
                        <div class="d-flex justify-content-between">
                          <div class="text-primary">{{'DATA_STUDIO.PREVIEW.SELECT_ALL' | translate }}</div>
                          <div class="d-flex align-items-center justify-content-end">
                            {{' ' + (devicesSelected$ | async)?.length}} {{'COMMON.OF' |translate}} {{selectedDevices?.length}}
                          </div>
                        </div>
                      </mat-checkbox>
                    </div>
                    <div class="signal-grid">
                      @for (v of selectedDevices; track $index; let i = $index) {
                        <mat-option class="data-studio-multi-select" [value]="v"
                          (click)="triggerOnePerOneTurbine()">
                          {{ getAssetName(v) }}
                        </mat-option>
                      }
                    </div>
                  </mat-select>
                </div>
                <div class="p-2 w-100 mt-3">
                  <div class="w-100">
                    @if (selectedTab === 1) {
                      <app-preview-chart
                        class="w-100"
                        [loading]="loadingData"
                        [unitsSelected]="unitsMultiDeviceSelected"
                        [series]="seriesMultiDevice">
                      </app-preview-chart>
                    }
                  </div>
                </div>
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </lib-card-body>
    </lib-card>
  }
</ng-template>
<ng-template #metadata>
  <app-data-metadata></app-data-metadata>
</ng-template>

<ng-template #normal>
  @if (view?.id === 0) {
    <div class="col-xl">
      <ng-container *ngTemplateOutlet="dataAnalysis"></ng-container>
    </div>
  }
  @if (view?.id == 1) {
    <div class="col-xl">
      <ng-container *ngTemplateOutlet="scada"></ng-container>
    </div>
  }
  @if (view?.id == 2) {
    <div class="col-xl">
      <ng-container *ngTemplateOutlet="liveData"></ng-container>
    </div>
  }
  @if (view?.id == 3) {
    <div class="col-xl">
      <ng-container *ngTemplateOutlet="tlogs"></ng-container>
    </div>
  }
  @if (view?.id == 4) {
    <div class="col-xl">
      <ng-container *ngTemplateOutlet="parkData"></ng-container>
    </div>
  }
  @if (view?.id == 5) {
    <div class="col-xl">
      <ng-container *ngTemplateOutlet="metadata"></ng-container>
    </div>
  }
</ng-template>
